/* eslint-disable no-param-reassign */
/* global slideUp, slideDown, attachEvent, windowWidth, breakpointSm */
// **************************************************
// Membership accordions
// **************************************************

function closeAccordions() {
  if (windowWidth() < breakpointSm) {
    const steps = document.querySelectorAll('.membership-banner__step.is-open');

    steps.forEach((step) => {
      const stepText = step.querySelectorAll('.membership-banner__step-text')[0];
      step.classList.remove('is-open');
      slideUp(stepText, 300);
    });
  }
}

window.addEventListener('resize', () => {
  const stepTexts = document.querySelectorAll('.membership-banner__step-text');
  stepTexts.forEach((stepText) => {
    stepText.style.display = windowWidth() > breakpointSm ? 'block' : 'none';
  });
});

attachEvent('.membership-banner__step-title', 'click', ({ target }) => {
  if (windowWidth() < breakpointSm) {
    const step = target.closest('.membership-banner__step');
    const stepText = step.querySelectorAll('.membership-banner__step-text')[0];

    if (step.classList.contains('is-open')) {
      closeAccordions();
    } else {
      closeAccordions();
      step.classList.add('is-open');
      slideDown(stepText, 300);
    }
  }
});
